<template>
    <section class="our-new-menu">
        <v-container>
        <h2 class="text-center font-weight-bold text-capitalize mt-10 mb-10">{{$t("home.NewMenu")}}</h2>
        <v-row
        v-if="loading"
        >
        <v-col
        :cols="12"
        :md="4"
        :sm="6"
        >
         <v-skeleton-loader
              class="mx-auto white"
              max-width="370"
              :loading='false'
              type="image,article"
            ></v-skeleton-loader>  
        </v-col>
        <v-col
        :cols="12"
        :md="4"
        :sm="6"
        class="d-none d-sm-block"
        >
         <v-skeleton-loader
              class="mx-auto white"
              max-width="370"
              :loading='false'
              type="image,article"
            ></v-skeleton-loader>  
        </v-col>
        <v-col
        :cols="12"
        :md="4"
        :sm="6"
        class="d-none d-sm-none d-md-block"
        >
         <v-skeleton-loader
              class="mx-auto white"
              max-width="370"
              :loading='false'
              type="image,article"
            ></v-skeleton-loader>  
        </v-col>
        </v-row>
        <Carousel
        style="direction:ltr"
        :autoplay='true'
         :autoplayHoverPause='true'
         :paginationEnabled='false'
         :scrollPerPage='false'
         :autoplayTimeout="8000"
         :autoplayDirection='$vuetify.rtl? "backward":"forward"'
         :loop='true'
         :perPageCustom='[[0,1],[576,1],[768,2],[992,3]]'
        >
         <Slide
         v-for="(menu, index) in newMenus" :key="index"
         class="d-flex justify-center"
         >
         <v-card
          max-width="400"
          class="mx-auto mr-5 ml-5 gray lighten-4"
          height="300"
          flat
          :outlined='true'
          :hover="true"
          :style='$vuetify.rtl? {direction:"rtl !important"}:""'
    >
      <div class="d-flex justify-center pt-3 align-center ">
      <v-badge
      :content="menu.discount+'% off'"
      overlap
      :value="menu.discount!=''"
      bottom
      offset-x="0"
      color="green"
      class="font-weight-bold"
      >
         <v-img  :src="menu.img" alt="menu.title" 
          max-width="108"
          height="108"
          :contain="true"
          >
          <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
       </v-badge>
      </div>
      <v-card-title  class="red--text font-weight-bold" v-text="getName(menu,'title')"></v-card-title>
      <v-card-subtitle  class="pb-2 font-weight-bold">
      {{$t('orders.facteur.price')}} :<span :class="menu.discount!='' ? 'text-decoration-line-through' :''"> {{menu.price}}$</span>
      <span class="ml-6 mr-6  grey white--text pa-1 pr-3 pl-3 rounded" v-if="menu.discount!=''">{{priceAfterDiscount(menu)}}$</span>
      </v-card-subtitle>
      <v-card-text class="text--primary">
        <div v-text="menu[lang].description"></div>
      </v-card-text>
    </v-card>
         </Slide>
        </Carousel>
        </v-container>
    </section>
</template>

<script>
import {Carousel,Slide} from 'vue-carousel';
import firebase from '@/firebase/index';
import {lang} from '@/mixins/index';

export default {
    name:'new_menu',
    data() {
        return {
            /*newMenussss:[
                {
                categorie:'pizza',
                title:'pizza one',
                img:'pizza.png',
                description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
                price:'12',
                discount:'20'
                },{
                categorie:'salad',
                title:'Fattoush Salad',
                img:'Fattoush Salad.png',
                description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
                price:'120',
                discount:'15'
                },{
                categorie:'burgures',
                title:'Big Burger',
                img:'Big Burger .png',
                description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
                price:'34',
                discount:''
               }
            ],*/
            loading:false,
            numItems:3,
            newMenus:[]
        }
    },
    mixins:[lang],
    methods: {
        priceAfterDiscount(menu){
           return parseInt(menu.price) - (parseInt(menu.price)*parseInt(menu.discount))/100;
        },
        getNewMenuData(){
            this.numItems=3;
             this.loading=true;
             this.newMenus=[];
          const storage = firebase.storage();
          firebase.firestore().collection('newMenu').get()
          .then((snapshot)=>{
            this.numItems=snapshot.docs.length;
         snapshot.forEach(doc=>{
          storage.ref(doc.data().img).getDownloadURL()
            .then((url) => {
             this.newMenus.push({
                 title:doc.data().title,
                 ar:{
                   title:doc.data().ar.title,
                   description:doc.data().ar.description,
                 },
                 fr:{
                   description:doc.data().fr.description,
                 },
                 en:{
                   description:doc.data().en.description,
                 },
                 img:url,
                 price:doc.data().price,
                 discount:doc.data().discount
               });
               this.loading=false;
            })
         })
       })
    }
    },
    components:{
        Carousel,
        Slide
    },
    created(){
        this.getNewMenuData();
    }
}
</script>